<template>
  <el-select
    :value="value"
    size="small"
    @change="handleChange"
    placeholder="请选择"
    style="width: 100%"
    filterable
  >
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    ></el-option>
  </el-select>
</template>

<script>
import { templateGroupList } from '@/service/getData'

export default {
  props: {
    value: '',
    type: Number,
    codeType: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      lists: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      let res = await templateGroupList({
        type: this.type,
        code_type: this.codeType,
      })
      if (res.status == 0) {
        this.lists = res.data
      }
    },
    handleChange(e) {
      this.$emit('input', e)
    },
  },
}
</script>